export enum DrawerView {
  Default = 0,
  AllBookkeepingItems = 1,
  AllTransactions = 2,
}
